import React from "react";
import {Card, Image, Label} from "semantic-ui-react";
import {APP} from "../../../constants";
import {Link} from "react-router-dom";
import moment from "moment";

export const PostCard = ({post, path, home}) => {

    const {id, title, slug, category_id, created_at, category} = post;

    const image = APP.API_URL + '/files/posts/image/' + post.image.replace('big', 'small');
    const created = moment(created_at);
    const to = home ? `${path}/home/${category_id}/${category.slug}#author=${category.author}` : `${path}/read/${id}/${slug}?category=${category_id}`
    return (
        <Card
            as={Link}
            style={{marginBottom: 16}}
            to={to}
        >
            <div
                className={'place-card'}
                style={{
                    backgroundImage: `url(${image})`,
                }}
            >
                {/*<Label icon={'heart'} corner={'right'}/>*/}
                {/*<Label color={'green'} icon={'star'} corner={'left'}/>*/}
            </div>
            <Card.Content>
                <Card.Header>{home ? category.author : title}</Card.Header>
                {
                    !home && <Card.Meta>
                        <span className='date'>{created.format('MMM D,Y')}</span>
                    </Card.Meta>
                }
            </Card.Content>
        </Card>
    );
};